import { Link } from "react-router-dom";
import { MapPin, Users } from "lucide-react";

export default function VenueCard({ venue }) {
  const img = venue.images?.[0] || "https://images.unsplash.com/photo-1772903191730-fa9bc478c1de?w=800";
  return (
    <Link
      to={`/venues/${venue.id}`}
      data-testid={`venue-card-${venue.id}`}
      className="group block bg-white border border-ink/10 hover:border-ink/30 transition-all duration-300"
    >
      <div className="aspect-[4/5] overflow-hidden bg-cream">
        <img
          src={img}
          alt={venue.name}
          className="w-full h-full object-cover group-hover:scale-[1.04] transition-transform duration-[800ms] ease-out"
        />
      </div>
      <div className="p-6">
        <h3 className="font-heading font-light text-2xl leading-tight tracking-editorial text-ink mb-4 line-clamp-1 group-hover:text-accent transition-colors">
          {venue.name}
        </h3>
        <div className="flex items-center justify-between text-[12px] text-ink/55 pt-4 border-t border-ink/10">
          <div className="flex items-center gap-3">
            <span className="flex items-center gap-1.5"><MapPin className="h-3 w-3" />{venue.city}</span>
            <span className="flex items-center gap-1.5"><Users className="h-3 w-3" />{venue.capacity}</span>
          </div>
          <span className="font-heading text-base text-ink">
            <span className="font-display italic">{venue.price_per_day}</span>€<span className="text-ink/40 text-xs">/j</span>
          </span>
        </div>
      </div>
    </Link>
  );
}
